<div class="toggle-cols" (click)="colsPanel.toggle($event)">
  <sxw-svg-icon name="plus" width="20" height="20"></sxw-svg-icon>
</div>
<sxw-overlay-panel #colsPanel>
  <div class="search">
    <sxw-svg-icon name="magnifying-glass" width="20" height="20" class="search__icon"></sxw-svg-icon>
    <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearch($event)" class="search__input" [placeholder]="'Search' | translate" />
  </div>
  <div class="cols">
    @for (col of visibleCols(); track col.label; let i = $index) {
      @if (col.label) {
        <div class="col" (click)="toggleCol(col)">
          <span class="col-label">{{ col.label | translate }}</span>
          <sxw-svg-icon name="checked" width="10" height="10"></sxw-svg-icon>
        </div>
      }
    }

    @for (col of hiddenCols(); track col.label; let i = $index) {
      @if (col.label) {
        <span class="col" (click)="toggleCol(col)">{{ col.label | translate }}</span>
      }
    }
  </div>
</sxw-overlay-panel>
